function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { GALLERY_CONSTS } from 'pro-gallery';
import INFO_EVENTS from '../../common/constants/infoEvents';
import LoveFull from '../svgs/components/love_full';
import LoveEmpty from '../svgs/components/love_empty';

var LoveButton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LoveButton, _React$Component);

  function LoveButton(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.toggleLove = _this.toggleLove.bind(_assertThisInitialized(_this));
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    _this.getMobileEnabledClick = _this.getMobileEnabledClick.bind(_assertThisInitialized(_this));
    _this.state = {
      animate: false
    };
    return _this;
  }

  var _proto = LoveButton.prototype;

  _proto.onKeyPress = function onKeyPress(e) {
    switch (e.keyCode || e.charCode) {
      case 32: // space

      case 13:
        // enter
        e.preventDefault();
        e.stopPropagation();
        this.toggleLove(e);
        return false;

      default:
        break;
    }
  };

  _proto.toggleLove = function toggleLove(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.actions.eventsListener(INFO_EVENTS.LOVE_BUTTON_CLICKED, this.props);
    this.setState({
      animate: !this.props.isLoved
    });
  };

  _proto.buttonClasssName = function buttonClasssName() {
    var className = [];
    className.push('info-element-social-love');

    if (this.props.isLoved) {
      className.push('love_full info-element-loved');
    } else {
      className.push('love_empty');
    }

    if (this.state.animate) {
      className.push('love-animation');
    }

    return className.join(' ');
  };

  _proto.getMobileEnabledClick = function getMobileEnabledClick(action) {
    return this.props.isMobile ? {
      onTouchEnd: action
    } : {
      onClick: action
    };
  };

  _proto.createLoveCounter = function createLoveCounter() {
    var count = this.props.loveCount || 0;
    return !!this.props.showCounter && count > 0 ? /*#__PURE__*/React.createElement("i", {
      "data-hook": "love-counter",
      className: 'info-member info-element-social-love-count'
    }, count) : null;
  };

  _proto.render = function render() {
    var loveCounter = this.createLoveCounter();
    var clickAction = this.props.viewMode === GALLERY_CONSTS.viewMode.SITE || this.props.viewMode === GALLERY_CONSTS.viewMode.SEO ? this.getMobileEnabledClick(this.toggleLove) : {
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    };
    var loveColor = this.props.isLoved ? {
      color: 'red'
    } : {};
    return /*#__PURE__*/React.createElement("span", _extends({
      className: 'info-member info-element-social-love info-element-social-button',
      "data-hook": "love-button"
    }, clickAction, {
      onKeyDown: this.onKeyPress,
      tabIndex: this.props.styleParams.isSlideshow && this.props.currentIdx === this.props.idx ? 0 : -1,
      role: "checkbox",
      "aria-checked": this.props.isLoved,
      "aria-label": 'Love'
    }), /*#__PURE__*/React.createElement("button", {
      "data-hook": "love-icon",
      className: this.buttonClasssName(),
      style: loveColor,
      tabIndex: -1
    }, this.props.isLoved ? /*#__PURE__*/React.createElement(LoveFull, {
      size: "21"
    }) : /*#__PURE__*/React.createElement(LoveEmpty, {
      size: "21"
    })), loveCounter);
  };

  return LoveButton;
}(React.Component);

export default LoveButton;